import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import frCommon from './fr/common.json';
import enCommon from './en/common.json';
import frPages from './fr/pages.json';
import enPages from './en/pages.json';
import frRealisations from './fr/realisations.json';
import enRealisations from './en/realisations.json';
import frJobs from './fr/jobs.json';
import enJobs from './en/jobs.json';

const savedLanguage = localStorage.getItem('language');

i18n.use(initReactI18next).init({
  resources: {
    fr: { common: frCommon, pages: frPages, realisations: frRealisations, jobs: frJobs },
    en: { common: enCommon, pages: enPages, realisations: enRealisations, jobs: enJobs },
  },
  lng: savedLanguage || 'fr',
  fallbackLng: 'fr',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
  document.documentElement.lang = lng;
});

document.documentElement.lang = i18n.language;

export default i18n;
